module.exports = __webpack_public_path__ + "img/3798f2c.png";